import type { RejectInvoicePayload, RejectInvoiceResponse } from './types';

import { ENDPOINT } from '~/constants/endpoints';

import type { UUID } from '~/types/common';

import { vestigasApi } from '~/services/kyClient';

import { zodInvoiceDetailSchema } from '../useQueryInvoiceDetail/validations';

import { zodRejectInvoicePayloadSchema } from './validations';

/**
 * Rejects an invoice and optionally emails the issuer.
 *
 * The API answers 200 when the email was sent before the request returned and
 * 202 when it is still being sent; the body is the invoice detail either way.
 * `userFileIds` names the invoice's own user files and `fileRoles` its process
 * files by role; only the listed files are attached.
 *
 * @param invoiceId - Invoice identifier.
 * @param payload - Optional timeline comment and optional issuer email; an
 *   empty object only sets the status.
 * @returns The invoice detail after rejection.
 * @see https://app.dev.vestigas.com/redoc#tag/Invoices/operation/reject_invoice_invoices__invoice_id__reject_post
 */
export async function rejectInvoice(
  invoiceId: UUID,
  payload: RejectInvoicePayload,
) {
  return vestigasApi
    .post(ENDPOINT.INVOICE.REJECT(invoiceId), {
      json: payload,
      validate: {
        body: zodRejectInvoicePayloadSchema,
        isResponseSensitive: true,
        response: zodInvoiceDetailSchema,
      },
    })
    .json<RejectInvoiceResponse>();
}
